module.exports = __webpack_public_path__ + "media/images/expert__leonard-thurre-f9c9396f175cecf0b73efde3db015bfa.png";